import { APP_HEADER_ID } from './constants/header'

export const getAppHeader = () => {
  return typeof document !== undefined
    ? document?.getElementById(APP_HEADER_ID)
    : undefined
}
